import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  emptyOption: {
    minHeight: '1.5rem !important',
  },
}));

export default useStyles;
